<a class="yllw-sidenav__item-link" [routerLink]="link()"
    routerLinkActive="yllw-sidenav__item-link--active"
    [routerLinkActiveOptions]="activeOptions()"
    pRipple [pTooltip]="item().labelKey | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
    <i class="pi pi-{{ item().icon }} yllw-sidenav__item-icon"></i>
    @if (expanded()) { <span class="yllw-sidenav__item-text">{{ item().labelKey | translate }}</span> }
</a>
